import * as React from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';
import { QRCodeCanvas } from '@cian/frontend-qrcode';
import { CustomTooltip, UIText2 } from '@cian/ui-kit';

import * as styles from './PhoneLinkQRCode.css';
import { useApplicationContext } from '../../utils/applicationContext';

interface IQRCodePhone {
  phoneLink: string;
  onQRShow(): void;
}

export const PhoneLinkQRCode = ({ phoneLink, onQRShow }: IQRCodePhone): React.JSX.Element => {
  const { logger } = useApplicationContext();
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpenState] = React.useState(false);
  const [openedOnce, setOpenedOnce] = React.useState(false);

  const setOpen = React.useCallback(() => {
    setOpenState(true);

    /* istanbul ignore else */
    if (!openedOnce) {
      onQRShow();

      setOpenedOnce(true);
    }
  }, [setOpenState, openedOnce, setOpenedOnce, onQRShow]);
  const setClose = React.useCallback(() => setOpenState(false), [setOpenState]);

  return (
    <ErrorLogComponent logger={logger}>
      <CustomTooltip
        open={open}
        placement="left"
        maxWidth={190}
        anchorRef={anchorRef}
        content={
          <div data-testid="phoneLinkQrCode" className={styles['container']}>
            <div className={styles['code']}>
              <QRCodeCanvas
                id="phoneLinkQrCode"
                width={166}
                text={phoneLink}
                color={{
                  // Во время миграций важно сохранить hex-значения цветов для этой библиотеки.
                  dark: '#152242',
                  light: '#ffffff',
                }}
              />
            </div>
            <UIText2 color="black_60">Просто наведите камеру, чтобы набрать номер</UIText2>
          </div>
        }
        closeButton={false}
        onMouseLeave={setClose}
      />
      <div
        data-testid="qrCodeImg"
        className={styles['preview']}
        onMouseEnter={setOpen}
        onMouseLeave={setClose}
        ref={anchorRef}
      />
    </ErrorLogComponent>
  );
};
